import { useEffect } from 'react';
import { ResourcesPage } from 'store/types';
import size from 'lodash-es/size';
import { useAppDispatch } from 'store/hooks';
import { getResourceList } from 'store/page/pageSlice';

// Перезапросит выборку, если ее размер по каким либо причинам изменился от того, что пришло в ответе
export const useResourceReRequest = (
  resourcePage: ResourcesPage | undefined
) => {
  const dispatch = useAppDispatch();

  const currentSize = resourcePage ? size(resourcePage.data) : 0;
  const responseTotal = resourcePage ? resourcePage.responseTotal : 0;

  useEffect(() => {
    if (currentSize < responseTotal && resourcePage) {
      dispatch(getResourceList(resourcePage.requestMeta));
    }
  }, [currentSize, responseTotal, resourcePage]);
};
